// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__NB0Od","boxTitle":"Qualiphy_boxTitle__3mypH","box":"Qualiphy_box__2coZZ","toggleWrap":"Qualiphy_toggleWrap__2J_RH"};